var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",class:[_vm.stackedClass]},[(_vm.hasLabel)?_c('div',{staticClass:"border-transparent"},[_vm._t("label")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"border-transparent"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }